import { createTheme } from "@mui/material/styles";
import palette from "./palette";
import typography from "./typography";
import components from "./components";
import shadows from "./shadows";

const buildTheme = (mode = "light") =>
  createTheme({
    palette: palette[mode],
    typography,
    components,
    shadows,
    shape: {
      borderRadius: 12,
    },
  });

export default buildTheme;
